import React from 'react';
import {
  Modal, List,
} from 'antd';
import { ErrorMsgWrapper } from './styles';

const ErrorMsgModal = (title, dataSource) => {
  Modal.info({
    width: '50vw',
    title,
    content: (
      <ErrorMsgWrapper>
        <List
          bordered
          dataSource={dataSource}
          renderItem={item => (
            <List.Item>
              {item}
            </List.Item>
          )}
        />
      </ErrorMsgWrapper>
    ),
  });
};

export default ErrorMsgModal;
